/* eslint-disable react/no-array-index-key */
/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

'use client'

import clsx from 'clsx'
import React, { useState } from 'react'

import s from './FAQ.module.css'

function QuestionItem({ question }) {
  const [show, setShow] = useState(false)
  const handleShow = () => setShow((state) => !state)

  return (
    <div
      className={clsx(s.questionItem, show && s.questionItemOpened)}
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
    >
      <div className={s.questionItemQuestion} itemProp="name" onClick={handleShow}>
        {question.question}
        <svg
          className={s.icon}
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.75 9C15.75 9.14918 15.6907 9.29226 15.5852 9.39775C15.4798 9.50324 15.3367 9.5625 15.1875 9.5625H9.5625V15.1875C9.5625 15.3367 9.50324 15.4798 9.39775 15.5852C9.29226 15.6907 9.14918 15.75 9 15.75C8.85082 15.75 8.70774 15.6907 8.60225 15.5852C8.49676 15.4798 8.4375 15.3367 8.4375 15.1875V9.5625H2.8125C2.66332 9.5625 2.52024 9.50324 2.41475 9.39775C2.30926 9.29226 2.25 9.14918 2.25 9C2.25 8.85082 2.30926 8.70774 2.41475 8.60225C2.52024 8.49676 2.66332 8.4375 2.8125 8.4375H8.4375V2.8125C8.4375 2.66332 8.49676 2.52024 8.60225 2.41475C8.70774 2.30926 8.85082 2.25 9 2.25C9.14918 2.25 9.29226 2.30926 9.39775 2.41475C9.50324 2.52024 9.5625 2.66332 9.5625 2.8125V8.4375H15.1875C15.3367 8.4375 15.4798 8.49676 15.5852 8.60225C15.6907 8.70774 15.75 8.85082 15.75 9Z"
            fill="white"
          />
        </svg>
      </div>
      <div className={s.questionItemAnswer} itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
        <div itemProp="text">{question.answer}</div>
      </div>
    </div>
  )
}

export function FAQ({ questions, className }) {
  return (
    <div className={clsx(s.root, className)}>
      <h2 className={s.title}>FAQs</h2>

      <div className={s.questions}>
        {questions.map((question, index) => (
          <QuestionItem key={index} question={question} />
        ))}
      </div>
    </div>
  )
}
